import React from 'react';
import KnockoutComponent from './App';
import { useKnockout, useMedalsList } from '../queries/digitalScoringHooks';
import { useParams, useRouteMatch } from 'react-router-dom';
import EventName from '../Component/EventName';
import { useShowKhelo } from 'utils/HooksUtils';
// import Helmet from 'react-helmet';
import MedalsFinals from '../Component/MedalsFinals';
import DetailItemLoader from '../../components/DetailItemLoader';
import { noDataText } from 'data/noDataText';

export default function Knockout() {
  const base = useRouteMatch('/:user/score/knockout/:sportEvent');
  const data = useKnockout({
    sport_event: useParams().sportEvent,
  });
  const medalsListQueryData = useMedalsList({
    sport_event: useParams().sportEvent,
  });
  const isKhelo = useShowKhelo();
  console.log(data.data);
  return (
    <>
      {/* <Helmet>
        <title>Draws & Schedule | KIYG Haryana 2021</title>
        <meta
          name="description"
          content="Check the DRAWS & SCHEDULE now! 25 Sports | 4th - 13th June 2022. Watch India's finest U/18 athletes represent their respective states at #KIYG2021!"
        />
        <meta property="og:title" content="Draws & Schedule | KIYG Haryana 2021" />
        <meta
          property="og:description"
          content="Check the DRAWS & SCHEDULE now! 25 Sports | 4th - 13th June 2022. Watch India's finest U/18 athletes represent their respective states at #KIYG2021!"
        />
      </Helmet> */}
      <EventName sport_event={base.params.sportEvent} />
      <DetailItemLoader queryData={medalsListQueryData}>
        {({ data }) => {
          if (data.length !== 0) {
            return (
              <MedalsFinals
                medalsListQueryData={medalsListQueryData}
                isValid={data?.error?.length}
              />
            );
          }
          return null;
        }}
      </DetailItemLoader>
      {data.data && data?.data?.columns?.length ? (
        <KnockoutComponent data={data.data} />
      ) : data.isFetched ? (
        <div className="my-8 p-5 bg-gradient-to-br from-blue-75 to-purple-75 rounded-lg">
          <div
            className="text-center p-8 text-white font-bold rounded-lg mt-4"
            style={{
              background: `url(/assets/sfa_online/node_modules/knockout-component/src/direflow-components/knockout-component/components/images/pattern.png) no-repeat -5% , conic-gradient(from 51.11deg at 50% 58.75%, ${
                isKhelo ? '#1E4182' : '#8E2DE2'
              } 0deg, ${isKhelo ? '#053470' : '#4A00E0'} 360deg)`,
            }}
          >
            {noDataText}
          </div>
        </div>
      ) : null}
    </>
  );
}
